var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form-login"},[_c('span',[_vm._v("Sign in")]),_c('LoginGoogleButton')],1)}
var staticRenderFns = []

export { render, staticRenderFns }